export default class Cart {

    static initial() {
        this.counter();
        this.calculateCartPrice();
        this.actionProducts();
    }

    /**
     * Counter area
     */
    static counter() {
        $(document).on('click', '.counter span:not(.disabled)', function () {
            let $input = $(this).siblings('input'),
                value = Number($input.val()),
                min = Number($input.attr('data-min')),
                max = Number($input.attr('data-max')),
                typeAction = $(this).attr('data-attr');

            if(typeAction === 'plus' && value < max) {
                $input.val(++value);
            } else if (typeAction === 'minus' && value > min) {
                $input.val(--value);
            }

            if(value >= max) {
                $(this).closest('.counter').find('span[data-attr="plus"]').addClass('disabled');
            } else {
                $(this).closest('.counter').find('span[data-attr="plus"]').removeClass('disabled');
            }

            if(value <= 1) {
                $(this).closest('.counter').find('span[data-attr="minus"]').addClass('disabled');
            } else {
                $(this).closest('.counter').find('span[data-attr="minus"]').removeClass('disabled');
            }

            //Save count
            let id = $(this).closest('.item_product_cart').attr('data-id');
            $(document).trigger('trigger.count.product', [id, Number(value)]);

        });

        $(document).on('keypress keyup blur', '.counter input', function (event) {
            let val = $(this).val().replace(/[^\d].+/, "");
            $(this).val(val);
            if ((event.which < 48 || event.which > 57)) {
                event.preventDefault();

                //Save count
                if(val) {
                    let id = $(this).closest('.item_product_cart').attr('data-id');
                    $(document).trigger('trigger.count.product', [id, Number(val)]);
                }
            }
        });

        $(document).on('blur', '.counter input', function () {
            let val = 0,
                max = Number($(this).attr('data-max')),
                min = Number($(this).attr('data-min'));

            if(Number($(this).val()) < min) {
                val = min;
                $(this).val(min);
                $(this).closest('.counter').find('span[data-attr="minus"]').addClass('disabled');
            } else {
                $(this).closest('.counter').find('span[data-attr="minus"]').removeClass('disabled');
            }

            if(Number($(this).val()) > max) {
                val = max;
                $(this).val(max);
                $(this).closest('.counter').find('span[data-attr="plus"]').addClass('disabled');
            } else {
                $(this).closest('.counter').find('span[data-attr="plus"]').removeClass('disabled');
            }

            //Save count
            if(val) {
                let id = $(this).closest('.item_product_cart').attr('data-id');
                $(document).trigger('trigger.count.product', [id, Number(val)]);
            }
        });
    }

    /**
     * Action witch products
     * change count
     * remove product from cart list
     */
    static actionProducts() {
        let self = this;

        //Change count
        $('.counter input[name="product_count"]').bind('change paste blur', function () {
            self.calculateCartPrice();
        });
        //TODO: not very good
        $('.counter > span').bind('click', function () {
            setTimeout(function () {
                self.calculateCartPrice();
            }, 100);
        });

        //Delete item
        $(document).on('click', '.delete_from_cart', function (e) {
            e.preventDefault();
            let $this = $(this),
                ID = $(this).attr('data-id'),
                confName = 'confirm:delete';
            if(!ID) {
                console.warn('Please set product ID');
            }

            //Confirm delete
            $(document).bind(confName, function () {
                $(document).unbind(confName);
                let $parentSection = $this.closest('.content');

                $('.item_product_cart[data-id='+ ID +']').remove();

                if(!$parentSection.find('.item_product_cart').length) {
                    window.location.href = indexUrl;
                }

                self.calculateCartPrice();
            });
        });
    }

    /**
     * Calculate total price on cart page
     */
    static calculateCartPrice() {
        let $products = $('.item_product_cart'),
            $totalInfo = $('.total_info'),
            totalProductPrice = 0,
            totalProductOldPrice = 0,
            totalSavePrice = 0;

        $products.each(function () {
            let count = Number($(this).find('input[name="product_count"]').val());

            //Find price and old price
            if($(this).find('span[data-price-now]').length) {
                let priceNow = parseFloat($(this).find('span[data-price-now]').attr('data-price-now')) * count;
                $(this).find('.prices_total .now i').html(priceNow.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));
                totalProductPrice += priceNow;
            }
            if($(this).find('span[data-price-old]').length) {
                let priceOld = parseFloat($(this).find('span[data-price-old]').attr('data-price-old')) * count;
                $(this).find('.prices_total .old i').html(priceOld.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));
                totalProductOldPrice += priceOld;
            } else if($(this).find('span[data-price-now]').length) {
                totalProductOldPrice += parseFloat($(this).find('span[data-price-now]').attr('data-price-now')) * count;
            }

        });

        //Calculate discount price
        totalSavePrice = totalProductOldPrice - totalProductPrice;

        //Show price for user
        if(totalProductOldPrice > 0) {
            $totalInfo.find('.total-product').html(totalProductOldPrice.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));
            $totalInfo.find('.total-product-wrap').show();
        } else {
            $totalInfo.find('.total-product-wrap').hide();
        }
        if(totalSavePrice > 0) {
            $totalInfo.find('.total-save').html(totalSavePrice.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));
            $totalInfo.find('.total-save').closest('.row_info').removeAttr('style');
        } else {
            $totalInfo.find('.total-save').closest('.row_info').hide();
        }

        //Total
        $totalInfo.find('.total-total').html(totalProductPrice.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));

    }

}
